import { updateState } from './admin-globals.js';
import { authHeaders } from './admin-auth.js';
import { escHtml, showToast } from './admin-ui-base.js';
import { fetchDuration, normalizeYoutubeVideoId } from './admin-yt.js';
import { upsertFromSearchItem } from './admin-library.js';

let _ytSearchHits = [];

export function openYTSearch() {
  document.getElementById('search-modal').classList.remove('hidden');
  document.getElementById('yt-search-input').focus();
}

export function closeYTSearch() {
  document.getElementById('search-modal').classList.add('hidden');
}

export async function searchYouTube() {
  const query = document.getElementById('yt-search-input').value.trim();
  if (!query) return;
  
  const resultsEl = document.getElementById('yt-search-results');
  resultsEl.innerHTML = '<div class="search-empty">BUSCANDO...</div>';
  
  try {
    const res = await fetch(`/api/youtube/search?q=${encodeURIComponent(query)}`, {
      headers: authHeaders(),
    });
    const data = await res.json();

    if (res.status === 401) {
      resultsEl.innerHTML = '<div class="search-empty">SESIÓN EXPIRADA</div>';
      showToast('VUELVE A INICIAR SESIÓN', true);
      return;
    }
    if (!res.ok) {
      resultsEl.innerHTML = '<div class="search-empty">ERROR EN LA BÚSQUEDA</div>';
      showToast(data.detail || 'ERROR DE API YOUTUBE', true);
      return;
    }
    
    if (data.items && data.items.length > 0) {
      _ytSearchHits = data.items;
      resultsEl.innerHTML = data.items.map((item, i) => `
        <div class="search-item">
          <img src="${item.snippet.thumbnails.default.url}" class="search-item-thumb" alt="">
          <div class="search-item-info">
            <div class="search-item-title">${escHtml(item.snippet.title)}</div>
            <div class="search-item-channel">${escHtml(item.snippet.channelTitle)}</div>
          </div>
          <div class="search-item-actions">
            <button class="btn btn-secondary" onclick="window.previewFromSearchIndex(${i})">▶</button>
            <button class="btn btn-primary" onclick="window.addFromSearchIndex(${i})">+</button>
          </div>
        </div>
      `).join('');
    } else {
      resultsEl.innerHTML = '<div class="search-empty">SIN RESULTADOS</div>';
    }
  } catch(e) {
    resultsEl.innerHTML = '<div class="search-empty">ERROR EN LA BÚSQUEDA</div>';
    showToast('ERROR DE API YOUTUBE', true);
  }
}

export async function fetchYTDuration(videoId) {
  const statusEl = document.getElementById('yt-duration-status');
  if (!videoId) { statusEl.textContent = ''; return; }
  
  // Extraer ID si es una URL
  const id = normalizeYoutubeVideoId(videoId);
  
  statusEl.textContent = 'OBTENIENDO DURACIÓN...';
  statusEl.style.color = 'rgba(255,255,255,0.3)';
  
  if (!id) {
    statusEl.textContent = 'ID DE VÍDEO INVÁLIDO';
    statusEl.style.color = '#ff3366';
    return;
  }
  const duration = await fetchDuration(id);
  if (duration > 0) {
    const m = Math.floor(duration / 60);
    const s = Math.round(duration % 60);
    statusEl.textContent = `DURACIÓN: ${m}m ${s}s (${duration}s)`;
    statusEl.style.color = '#00ff88';
    document.getElementById('vid-yt-duration').value = duration;
    // Si el título está vacío, intentar sugerir uno? (Requiere otra llamada a la API)
  } else {
    statusEl.textContent = 'ERROR AL OBTENER DURACIÓN';
    statusEl.style.color = '#ff3366';
  }
}

function _itemFromSearchIndex(index) {
  const item = _ytSearchHits[index];
  if (!item?.id?.videoId) return null;
  return item;
}

window.addFromSearchIndex = (index) => {
  const item = _itemFromSearchIndex(index);
  if (!item) return;
  const id = item.id.videoId;
  const title = item.snippet.title || '';
  upsertFromSearchItem(item);
  updateState('returnToSearch', true);
  closeYTSearch();
  window.openAddVideo();
  document.getElementById('vid-type').value = 'youtube';
  document.getElementById('vid-yt-id').value = id;
  document.getElementById('vid-title').value = title;
  window.onTypeChange();
  fetchYTDuration(id);
};

window.previewFromSearchIndex = (index) => {
  const item = _itemFromSearchIndex(index);
  if (!item || !window.openSingleVideoPreview) return;
  window.openSingleVideoPreview({
    type: 'youtube',
    id: item.id.videoId,
    title: item.snippet.title || '',
  });
};
